<template>
  <v-card class="mx-auto my-12">
    <v-card-title>{{
        $store.state.text.pages.register.pageTitle
      }}
    </v-card-title>

    <v-card-text v-if="confirmed">
      {{ $store.state.text.pages.register.confirmedUser }}
    </v-card-text>
    <v-card-text v-if="error">
      <v-alert color="error" dismissible>
        {{ $store.state.text.pages.register.unconfirmed }}
      </v-alert>
    </v-card-text>
  </v-card>
</template>

<script>
import Axios from '@/core/Axios';
import { state } from '../../store/index';

export default {
  name: 'UserConfirm',
  data() {
    return {
      confirmed: false,
      error: false,
      uid: this.$route.params.uid,
      axios: new Axios(),
      host: process.env.VUE_APP_API_HOST,
    };
  },
  mounted() {
    if (this.uid) {
      this.confirmUser();
    }
  },
  methods: {
    confirmUser() {
      this.axios.makeCall('POST', 'norbit/customer/confirm', { uid: this.uid })
        .then((response) => {
          if (response) {
            this.confirmed = true;
          }
        })
        .catch((error) => {
          this.error = true;
        });
    },
  },
};
</script>

<style scoped>
</style>
